import { v4 as uuidv4 } from 'uuid';

export function BuyTogether(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'CompreJunto',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				title: 'Compre junto',
				subtitle: 'Compre junto e economize:',
				buttonText: 'Compre junto',
				benefitFilterTerm: 'Comprar juntos',
				maxItems: 6,
				showCurrentProduct: false,
				showSelectableBoxes: false,
				showButtonIcon: true,
				showListPrice: true,
				showSellingPrice: true,
				showInstallments: true,
				showTotalPrice: true,
				showNumberOfItems: true,
				promotionType: 'Compre Junto',
			},
			props,
		),
		childrenComponents,
		blocks,
	};
}
